import { Image } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import getImageSrc from "src/utils/getImageSrc";
import { SceneLayout } from "src/components/SceneLayout";
import { H2 } from "src/atoms/typography";
import FullScreen from "src/atoms/FullScreen";

export default function AlreadyOpen() {
  const { t } = useTranslation();
  return (
    <FullScreen>
      <SceneLayout
        centerProps={{ width: "320px", mt: "-32px" }}
        center={
          <>
            <Image width="206px" src={getImageSrc("already-running.svg")} />
            <H2 textAlign="center" color="highEmphasis" mt="24px">
              {t("onlyOneTab")}
            </H2>
          </>
        }
      />
    </FullScreen>
  );
}
